export default __webpack_public_path__ + "static/media/cohort-clipboard-check.2cb34e1f.svg";